import React from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import {
  FaUser,
  FaFileAlt,
  FaHeartbeat,
  FaClipboardList,
  FaNotesMedical,
} from 'react-icons/fa';

const ServiceMenu = ({ visible, onClose }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`fixed top-0 left-0 w-80 h-full bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${
        visible ? 'translate-x-0' : '-translate-x-full'
      }`}
      role="navigation"
      aria-label="Menu de serviços"
    >
      {/* Header do Drawer */}
      <div className="p-5 bg-secondary text-white flex items-center justify-between">
        <h2 className="text-lg font-bold text-white">Menu de Serviços</h2>
        <button
          onClick={onClose}
          className="text-white text-2xl hover:text-gray-300 transition duration-200 focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Fechar menu"
          aria-expanded={visible}
        >
          &times;
        </button>
      </div>

      {/* Conteúdo do Drawer */}
      <div className="p-6">
        <ul className="space-y-[5px]">
          {/* Links para os serviços */}
          <li>
            <Link
              to="/perfil-de-usuario"
              className="flex items-center gap-4 p-4 bg-gray-50 border rounded-lg shadow-md hover:bg-teal-50 hover:shadow-lg transition-all duration-200 mb-[8px] focus:outline-none focus:ring-2 focus:ring-teal-500"
              aria-label="Perfil de Usuário"
              onClick={onClose}
            >
              <FaUser className="text-2xl text-primary" />
              <span className="font-semibold text-gray-800">
                Perfil de Usuário
              </span>
            </Link>
          </li>

          <li>
            <Link
              to="/prontuario-eletronico"
              className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg shadow-md border hover:bg-teal-50 hover:shadow-lg transition-all duration-200 mb-[8px] focus:outline-none focus:ring-2 focus:ring-teal-500"
              aria-label="Consulta TUSS"
              onClick={onClose}
            >
              <FaClipboardList className="text-2xl text-primary" />
              <span className="font-semibold text-gray-800">Prontuário Eletrônico</span>
            </Link>
          </li>

          <li>
            <Link
              to="/consulta-tuss"
              className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg shadow-md border hover:bg-teal-50 hover:shadow-lg transition-all duration-200 mb-[8px] focus:outline-none focus:ring-2 focus:ring-teal-500"
              aria-label="Consulta TUSS"
              onClick={onClose}
            >
              <FaClipboardList className="text-2xl text-primary" />
              <span className="font-semibold text-gray-800">Consulta TUSS</span>
            </Link>
          </li>

          <li>
            <Link
              to="/gerar-laudos-e-guias-tiss"
              className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg border shadow-md hover:bg-teal-50 hover:shadow-lg transition-all duration-200 mb-[8px] focus:outline-none focus:ring-2 focus:ring-teal-500"
              aria-label="Gerar Laudos e Guias TISS"
              onClick={onClose}
            >
              <FaFileAlt className="text-2xl text-primary" aria-hidden="true" />
              <span className="font-semibold text-gray-900">
                Laudos e Guias TISS
              </span>
            </Link>
          </li>

          <li>
            <Link
              to="/consulta-cid"
              className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg shadow-md border hover:bg-teal-50 hover:shadow-lg transition-all duration-200 mb-[8px] focus:outline-none focus:ring-2 focus:ring-teal-500"
              aria-label="Consulta CID"
              onClick={onClose}
            >
              <FaNotesMedical className="text-2xl text-primary" />
              <span className="font-semibold text-gray-800">Consulta CID</span>
            </Link>
          </li>

          <li>
            <Link
              to="/analise-ecg"
              className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg border shadow-md hover:bg-teal-50 hover:shadow-lg transition-all duration-200 mb-[8px] focus:outline-none focus:ring-2 focus:ring-teal-500"
              aria-label="Análise de ECG"
              onClick={onClose}
            >
              <FaHeartbeat className="text-2xl text-primary" />
              <span className="font-semibold text-gray-800">
                Análise de ECG
              </span>
            </Link>
          </li>
        </ul>
      </div>

      {/* Footer com navegação para Planos */}
      <div className="p-5 bg-gray-100 border-t">
        <button
          onClick={() => navigate('/plano-premium')}
          className="w-full bg-secondary text-white font-semibold py-2 rounded-lg hover:bg-primary transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary"
        >
          Planos & Serviços
        </button>
      </div>
    </div>
  );
};

ServiceMenu.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ServiceMenu;
